import React from 'react';
import { IconProps } from '.';

const SvgFolderCheck = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='m15.883 11.764-1.106-1.014-3.62 3.945-2.147-1.988-1.02 1.1 3.253 3.012 4.64-5.055Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M10.401 3.25H1.25v17.5h21.5V6.25H12.401l-2-3ZM9.6 4.75l1 1.5H2.75v-1.5h6.849ZM2.75 19.25V7.75h18.5v11.5H2.75Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgFolderCheck;
